import { data as shardaData } from './shardaLandingPageData';

export const data = {
	...shardaData,
	leaderboardVisibleTime: '11:00 AM',
	leaderboardVisibleDate: '22nd September 2023',
};
